import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { LocaleContext } from '../../../../contexts/LocaleContext';
import css from './SiteFooter.module.scss';

interface Props extends React.HTMLProps<{}> {}

const SiteFooter = ({ intl }: Props & InjectedIntlProps) => {
  const localeCtx = React.useContext(LocaleContext);
  const intlPref = 'components.common.layouts.merchantGlobalFooter.siteFooter.';

  return (
    <div className={css.SiteFooter}>
      <div className={css.SiteFooter__Inner}>
        <span className={css.SiteFooter__Copyright}>©︎hey Inc.</span>
        <div className={css.SiteFooter__Links}>
          <a href="/terms" className={css.SiteFooter__Link}>
            {intl.formatMessage({ id: intlPref + 'links.terms' })}
          </a>
          <a href="/privacy" className={css.SiteFooter__Link}>
            {intl.formatMessage({ id: intlPref + 'links.policy' })}
          </a>
          <a href="/intl/ja/legal_notice" className={css.SiteFooter__Link}>
            {intl.formatMessage({ id: intlPref + 'links.sct' })}
          </a>
        </div>
        <div className={css.SiteFooter__Language}>
          <span>{intl.formatMessage({ id: intlPref + 'language' })}: </span>
          <select
            className={css.SiteFooter__LanguageSelect}
            onChange={e => {
              localeCtx.changeLocale(e.target.value);
            }}
            value={localeCtx.currentLocale}
          >
            <option value="ja">日本語</option>
            <option value="en">English</option>
            <option value="ko">한국어</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SiteFooter);
